export const FEATURE_FLAG_PIPELINE_CONFIG_SYNC = "content-analysis-config-sync";
export const FEATURE_FLAG_LENS_TESTER_MODEL_SELECTION = "lens-tester-model-selection";
export const FEATURE_FLAG_LENS_MODEL_SELECTOR = "lens-model-selector";
export const FEATURE_FLAG_SKIP_ENLIGHTEN_PRO_LICENSE_CHECK = "skip-enlighten-pro-license-check";
